import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import useFormValidation from 'hooks/useFormValidation';

import { inventoryApi } from 'api';

const validationSchema = {
  quantity: {
    required: 'Quantity is required',
    type: 'number',
    invalidNumber: 'Please enter a number',
  },
};

const initialValues = {
  quantity: '',
};

const InventoryQuantityEditModal = ({
  show,
  onHide,
  inventory,
  type,
  onSuccess,
}) => {
  const isUpdate = type === 'update';
  const [isLoading, setIsLoading] = useState(false);

  const { values, errors, touched, handleChange, handleBlur, resetForm } =
    useFormValidation(initialValues, validationSchema);

  useEffect(() => {
    if (!show) {
      resetForm();
    }
  }, [show]);

  const handleSubmit = async e => {
    if (e) e.preventDefault();

    if (isLoading || !values.quantity || errors.quantity) {
      return;
    }

    try {
      setIsLoading(true);
      if (isUpdate) {
        await inventoryApi.updateInventoryQuantity(inventory.id, {
          update_quantity: Number(values.quantity),
        });
      } else {
        await inventoryApi.addInventoryQuantity(inventory.id, {
          update_quantity: Number(values.quantity),
        });
      }
      toast.success(
        `Inventory quantity ${isUpdate ? 'updated' : 'added'} successfully`,
      );
      onHide();
      onSuccess();
    } catch (error) {
      toast.error(
        `Failed to ${isUpdate ? 'update' : 'add'} inventory quantity`,
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          {isUpdate ? 'Update' : 'Add'} Inventory Quantity
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Current Quantity: {inventory?.quantity}</Form.Label>

            <Form.Control
              type="text"
              value={values.quantity}
              onChange={e => handleChange('quantity', e.target.value)}
              onBlur={() => handleBlur('quantity')}
              isInvalid={touched.quantity && errors.quantity}
              placeholder="Enter Quantity..."
            />
            <Form.Control.Feedback type="invalid">
              {errors.quantity}
            </Form.Control.Feedback>
          </Form.Group>

          <Button type="submit" hidden />
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={isLoading || !values.quantity || errors.quantity}
        >
          {isLoading
            ? `${isUpdate ? 'Updating' : 'Adding'}...`
            : isUpdate
            ? 'Update'
            : 'Add'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InventoryQuantityEditModal;
